module.exports = __webpack_public_path__ + "img/xdcb.3ae6c176.png";